import { useEffect, useState } from 'react';
import { SelectedOptionsType } from '../components/TwFilters/TwFilters';
import { TwAutocompleteOption } from '../components/TwAutocomplete/TwAutocomplete';
import { useLocation } from 'react-router-dom';
import { useParseUrlSelections } from '../utils/urlUtils';

export const useGetUrlFilterParam = (urlKey: string | null): SelectedOptionsType => {
  const location = useLocation();
  const parseUrlSelections = useParseUrlSelections();
  const query = new URLSearchParams(location.search);

  const [filterParam, setFilterParam] = useState<SelectedOptionsType>(null);

  useEffect(() => {
    if (urlKey === 'pickup' || urlKey === 'delivery') {
      const from = query.get(`${urlKey}From`);
      const to = query.get(`${urlKey}To`);
      const id = query.get(`${urlKey}Id`);

      if (!from || !to || !id) return setFilterParam(null);

      return setFilterParam({
        from,
        to,
        id
      } as SelectedOptionsType);
    }

    if (urlKey === 'dispatcher' || urlKey === 'tagIds') {
      const value = query.getAll(urlKey);
      if (!value) return setFilterParam(null);
      const labels = value.reduce((a, c) => {
        const [label, id] = c.split('__');
        a.push({ label, id: id, value: id });
        return a;
      }, [] as unknown as TwAutocompleteOption[]);

      return setFilterParam(labels);
    }

    if (
      urlKey === 'orderNum' ||
      urlKey === 'tripNum' ||
      urlKey === 'custOrderNum' ||
      urlKey === 'truckId' ||
      urlKey === 'trailerId' ||
      urlKey === 'driver' ||
      urlKey === 'carrier' ||
      urlKey === 'divisionId' ||
      urlKey === 'deliveryLocation' ||
      urlKey === 'pickupLocation'
    ) {
      const value = query.getAll(urlKey);
      if (!value) return setFilterParam(null);
      const labels = value.reduce((a, c) => {
        const [, id] = c.split('__');
        a.push({ label: id, id: id, value: id });
        return a;
      }, [] as unknown as TwAutocompleteOption[]);

      return setFilterParam(labels);
    }

    if (urlKey === 'customer') {
      const labels = query.getAll(urlKey);
      const ids = query.getAll('customerId');
      if (!ids) return setFilterParam(null);
      const options: TwAutocompleteOption[] = labels.map((l, index) => {
        return { label: l, id: ids[index], value: ids[index] };
      });

      return setFilterParam(options);
    }

    const value = query.get(urlKey ?? '');
    if (!value) return setFilterParam(null);

    switch (urlKey) {
      case null:
        setFilterParam(null);
        break;
      case 'coverage':
        const coverages = parseUrlSelections(value, urlKey);
        setFilterParam(coverages);
        break;
      case 'bookingMode':
        const modes = parseUrlSelections(value, urlKey);
        setFilterParam(modes);
        break;
      case 'orderStatus':
      case 'tripStatus':
      case 'invoiceStatus':
        const labels = parseUrlSelections(value, urlKey);
        setFilterParam(labels);
        break;
    }
  }, [location.search]);

  return filterParam;
};
